import Head from 'next/head';
import styles from './styles.module.css';
import JWPlayer from "@/shared/components/JWPlayer/index.js";
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';

const stripHtml = (html) => html ? html.replace(/<[^>]*>/g, '').trim() : '';

const VideoViewer = (props) => {

    const {
        videoFiles,
        thumbnail,
        summary = '',
        url,
        tags,
        title,
    } = props;

    const tag = tags[0].name;

    return <div className={`${styles['video-container']}`}>
        {thumbnail && (
            <Head>
                <link rel="preload" href={thumbnail} as="image" fetchpriority="high" />
            </Head>
        )}
        <JWPlayer playerId={videoFiles._id} thumbnail={thumbnail} file={videoFiles.m3u8} playerScript="https://cdn.jwplayer.com/libraries/ogkm6Oc3.js" />
        <div className={`${styles['title-container']}`}>
            {tag && <a href={url} className={styles["tag"]}>{tag}</a>} <br />
            {title && <a href={url} className={styles["title-destacada-video"]}>{title}</a>} <br /> <br />
            {summary && summary !== '' ? <a href={url} className={styles["summary"]}>{stripHtml(summary)}</a> : null}
        </div>


        {!props.preview && <BannerHorizontalChico bannerId={`top`} />}


    </div>



}

export default VideoViewer;